/*================ nav Factory
 ========================================*/
angular
  .module('vppApp')
  .factory('navFactory', navFactory);

navFactory.$inject = ['$http', '$rootScope', '$log', 'vppConfig', 'VarientService'];

function navFactory($http, $rootScope, $log, vppConfig, VarientService) {
  return function(_theNav) {
    var varient = VarientService.getVarientName();
    var Url
    if (_theNav === "subNav" && varient === 'soty') {
      Url = vppConfig.contentNavigationPath + _theNav + "-" + varient + ".json";
    } else {
      Url = vppConfig.contentNavigationPath + _theNav + ".json";
    }
    console.log("navFactory", Url);
    var promise = $http.get(Url).then(function successCallback(data) {
      return data;
    }, function errorCallback(data) {
      return data;
    });

    return promise;
  };

};
